import { render, staticRenderFns } from "./mod5.vue?vue&type=template&id=39bd520a&scoped=true&"
import script from "./mod5.vue?vue&type=script&lang=js&"
export * from "./mod5.vue?vue&type=script&lang=js&"
import style0 from "./mod5.vue?vue&type=style&index=0&id=39bd520a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd520a",
  null
  
)

export default component.exports